import { RouteConfig } from 'vue-router';
import { TARGET_ENTITIES } from '@/utils/constants';

const MrtModule = () =>
  import(
    /* webpackChunkName: 'dashboard' */ '@/modules/machineReadableTemplate/MrtModule.vue'
  );

const MrtPage = () =>
  import(/* webpackChunkName: 'dashboard' */ './pages/MrtPage.vue');

export const MrtRoutes: RouteConfig[] = [
  {
    path: 'machine-readable-templates',
    component: MrtModule,
    props: true,
    meta: {
      middlewares: {
        canAccessEntity: TARGET_ENTITIES.submissionRequests
      }
    },
    children: [
      {
        path: '',
        meta: {
          title: 'Machine Readable Templates'
        },
        name: 'dashboard.organisation.investments.machine-readable-templates',
        component: MrtPage
      }
    ]
  }
];
